<script>
    export let skillList;
    export let title;
    import SkillDisplaySkill from "./skill_display_skill.svelte";

</script>

<div id="container">
    <h1 class="max-lines">{title}</h1>
    {#each skillList as skill}
        <SkillDisplaySkill {skill} />
    {/each}
</div>

<style>

    h1 {
        color: rgba(50, 0, 10, 0.9);
    }

    .max-lines {
        white-space: initial;
        width: 300px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 8;
        line-height: 1.5em;
    }

    #container {
        width: 260px;
        border: none;
        padding: 8px 16px;
        color: rgba(0, 60, 30, 0.8);
        font-weight: bold;
        border-radius: 8px;
        border-radius: 8px;
        margin-top: 8px;
        font-size: 12px;
    }

</style>